import fileSaver from "file-saver";
import Url from "url-parse";

// reverse transformation of `FileHandlingApiControllerExtension.DecodeUriSafeBase64String`
// in server-side
/**
 * Encode a string to a URI safe base64 string.
 *
 * @param {string} string - The string to encode
 * @return {string}
 */
export function encodeToUriSafeBase64String(string) {
	const utf8string = encodeURIComponent(string);
	const base6string = window.btoa(utf8string);

	return (
		base6string
			// eslint-disable-next-line sonarjs/slow-regex -- don't want to change that now
			.replace(/(=*)$/g, "")
			.replace("/", "_")
			.replace("+", "-")
	);
}

/**
 * Append a query parameter `pathname` to the provided URI.
 *
 * @param {string} uri - The URI to append the query parameter to
 * @param {string} pathname - The pathname to append
 * @return {string}
 */
export function setPathname(uri, pathname) {
	const url = new Url(uri);
	url.set("pathname", pathname);
	return url.toString();
}

/**
 * Make the browser download a file with the provided data.
 *
 * @param {object} options - Object parameters
 * @param {string} options.data - The data to download
 * @param {string} options.mimetype - The mimetype of the data
 * @param {string} options.filename - The name of the file to download
 */
export function download({ data, mimetype, filename }) {
	const blob = new Blob([data], { type: mimetype });
	fileSaver.saveAs(blob, filename);
}
